var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},_vm._l((18),function(i){return _c('img',{key:i,ref:"waves",refInFor:true,class:("waves" + i),attrs:{"src":_vm.$image('normal/illusts/waves.svg'),"alt":""}})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }